import siteData from '../site_data_util';
import striptags from 'striptags';
import baseSeoUtil from '../base_seo_util';

export default function(state = {}, action = {}) {
  // default variables
  const site = state?.config?.site;
  const siteConf = siteData || {};
  const franchisePage = action?.franchisePage || {};
  // eslint-disable-next-line
  const img = franchisePage?.['_embedded']?.['wp:featuredmedia']?.[0]?.source_url;
  const wpTitle = franchisePage?.title?.rendered;
  const socialTitle = wpTitle ? striptags(wpTitle).trim() : ''; // displays for twitter and social platforms
  const defaultSocialTitle = `${socialTitle} | Fast Company`;
  const franchiseExcerpt = franchisePage?.excerpt?.rendered;
  const defaultDescription = franchiseExcerpt
    ? striptags(franchiseExcerpt).trim()
    : '';

  // wordpress franchise
  const isFranchise = franchisePage?.type === 'franchise-list';
  const franchiseTitle = isFranchise ? wpTitle : null; // displays on google and browser tab
  const franchiseUrl = franchisePage?.acf?.publicUrl;

  // airtable franchise
  const airtableFranchise =
    franchisePage?.externalList?.metadata ||
    franchisePage?.externalList?.data?.Metadata?.[0] ||
    franchisePage?.externalList?.Metadata?.[0] ||
    franchisePage?.externalList?.pageMeta?.[0] ||
    {}; // this is for franchises that use airtable
  const airtableTitle =
    airtableFranchise?.['SEO title'] || airtableFranchise?.seo_title || '';
  const airtableImage =
    airtableFranchise?.['seo image'] || airtableFranchise?.social_image || '';
  const nbttURL = `https://www.fastcompany.com/next-big-things-in-tech/list/`;
  const isNBTT = airtableTitle.includes('Next Big Things in Tech');
  const airtableUrl = airtableFranchise?.pageurl || (isNBTT ? nbttURL : '');
  const airtableDescription =
    airtableFranchise?.['SEO description'] ||
    airtableFranchise?.seo_description ||
    '';
  const airtableTwitterTitle =
    airtableFranchise?.twitterTitle || airtableFranchise?.seo_title || '';
  const airtableTwitterDescription =
    airtableFranchise?.twitterDescription ||
    airtableFranchise?.seo_description ||
    '';

  return baseSeoUtil({
    site,
    siteConf,
    title: airtableTitle || franchiseTitle,
    overrideTitle: !!airtableTitle || !!franchiseTitle,
    url: airtableUrl || franchiseUrl,
    description: airtableDescription || defaultDescription,
    twitterDescription:
      airtableTwitterDescription || airtableDescription || defaultDescription,
    image: airtableImage || img,
    config: state?.config,
    facebookTitleOverride:
      airtableTitle || franchiseTitle || defaultSocialTitle,
    twitterTitleOverride:
      airtableTwitterTitle || franchiseTitle || defaultSocialTitle
  });
}
